export const routesSeo = {
  '/': {
    title: 'Home',
    description:
      '30-minute AI workouts and simple meal plans for busy professionals. No planning required.'
  },
  '/welcome': {
    title: 'Welcome',
    description: 'Get started with Calcium and set up your preferences for smarter routine recommendations.'
  },
  '/login': {
    title: 'Log in',
    description: 'Access your Calcium account to continue your fitness journey.'
  },
  '/signup': {
    title: 'Sign up',
    description: 'Join Calcium to create, track, and share your fitness routines.'
  },
  '/interests': {
    title: 'Interests',
    description: 'Tell us your fitness interests to personalize routines and recommendations.'
  },
  '/choice': {
    title: 'Generate routine',
    description: 'Generate AI-powered workout routines tailored to your goals.'
  },
  '/generated-stryds': {
    title: 'Generated stryds',
    description: 'Review AI-generated routines and pick what fits your schedule.'
  },
  '/add-routine': {
    title: 'Create routine',
    description: 'Create a custom fitness routine from scratch and track your progress.'
  },
  '/profile-page': {
    title: 'Your routines',
    description: 'View and manage your routines, progress, and achievements.'
  },
  '/explore-routines': {
    title: 'Explore routines',
    description: 'Discover community routines (stryds) based on your interests.'
  },
  '/people': {
    title: 'People',
    description: 'Find and follow people to stay motivated.'
  },
  '/upgrade': {
    title: 'Plans',
    description: 'Upgrade to unlock more AI generations, premium features, and priority support.'
  },
  '/plan-confirm': {
    title: 'Plan confirmation',
    description: 'Confirm your subscription to Calcium premium.'
  },
  '/meals': {
    title: 'Meals (Preview)',
    description: 'Preview meal plans that complement your training and goals.'
  },
  '/cali-chat': {
    title: 'Cali AI',
    description: 'Chat with Cali, your AI fitness assistant. Get workout suggestions, meal plans, and coaching.'
  },
  '/search': {
    title: 'Search',
    description: 'Search for people, routines, posts, and meals across Calcium.'
  },
  '/feed': {
    title: 'Feed',
    description: 'See what your fitness community is up to. Posts, workouts, and milestones.'
  },
  '/chat': {
    title: 'Messages',
    description: 'Chat with other athletes on Calcium.'
  },
  '/notifications': {
    title: 'Notifications',
    description: 'Stay updated on likes, comments, follows, and workout invites.'
  },
  '/terms': {
    title: 'Terms of Service',
    description: 'Read the terms that govern your use of Calcium, including memberships, community content, and AI-powered features.'
  },
  '/privacy': {
    title: 'Privacy Policy',
    description: 'Learn what information Calcium collects, how it is used, and the choices you have over your data.'
  },
  '/auth-callback': {
    title: 'Authenticating…',
    description: 'Completing sign-in and returning you to the app.',
    noIndex: true
  },
  '/nanotest': {
    title: 'Nano test',
    description: 'Nano Banana image test page.'
  },
  '/onboarding': {
    title: '30-minute AI plan',
    description: 'Structured 30-minute home workouts and simple meal plans built automatically for busy professionals.'
  },
  '/onboarding/personalize': {
    title: 'Personalize your 30-minute plan',
    description: 'Quick questions so your AI coach can build a structured 30-minute plan around your schedule.'
  },
  '/onboarding/payment-success': {
    title: 'Unlocking your plan',
    description: 'Finalizing payment and preparing your routine.',
    noIndex: true
  },
  '/routine': {
    title: 'Opening routine',
    description: 'Redirecting to your routine.'
  }
};
